import { ArrowLeft } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

export default function ClienteDetalhePage() {
  const { id } = useParams<{ id: string }>();

  return (
    <div className="space-y-6">
      <header>
        <Link
          to="/admin/clientes"
          className="inline-flex items-center gap-1.5 text-sm text-neutral-400 hover:text-neutral-100"
        >
          <ArrowLeft className="h-4 w-4" />
          Voltar para a lista
        </Link>
        <h1 className="mt-2 text-2xl font-semibold tracking-tight text-neutral-100">
          Detalhe do cliente
        </h1>
      </header>

      <Card>
        <CardHeader>
          <CardTitle>Em desenvolvimento</CardTitle>
          <CardDescription>
            A tela de detalhe do cliente vai chegar com D01.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-neutral-400">
            ID: <code className="font-mono text-xs">{id ?? '—'}</code>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
